import { TASK_STATUS } from "./taskStatus";
export default {
    [TASK_STATUS.PENDING]: "icon-clock-filled",
    [TASK_STATUS.CANCELLED]: "icon-stopwatch",
    [TASK_STATUS.IN_PROGRESS]: "icon-loading animate-rotation",
    [TASK_STATUS.ERROR]: "icon-info-circle-filled",
    [TASK_STATUS.COMPLETED]: "icon-check-circle-filled"
};
